import ApiService from './ApiService';

class BookmarkApi extends ApiService {
    constructor() {
        super('bookmarks');
    }

    getBookmarks(payload?: any) {
        return this.get('', payload);
    }

    addBookmark(payload: { publicationId: number, pageNumber: number, content?: string }) {
        return this.post('', payload);
    }

    deleteBookmark(id: string | number) {
        return this.delete(`${id}`);
    }

    checkBookmark(publicationId: string | number, page: number) {
        return this.get(`check/${publicationId}/${page}`);
    }
}

const bookmarkApi = new BookmarkApi();
export default bookmarkApi;
